import { createContext, useContext } from 'react';
import type { ReporteListItem } from '../api';

export const EMPRESA_TODAS = 'TODOS';

export interface EmpresaOption {
  value: string;
  label: string;
}

export interface EmpresaCtx {
  rfc:             string;
  setRfc:          (rfc: string) => void;
  reportes:        ReporteListItem[];
  nombresClientes: Record<string, string>;
  empresas:        EmpresaOption[];
  loading:         boolean;
  error:           string | null;
  refresh:         () => void;
}

export const EmpresaContext = createContext<EmpresaCtx | null>(null);

export function useEmpresa(): EmpresaCtx {
  const ctx = useContext(EmpresaContext);
  if (!ctx) throw new Error('useEmpresa debe usarse dentro de <EmpresaProvider>');
  return ctx;
}
